
import { useEffect, useState } from "react";
import axios from "axios";
import {
  FiGift,
  FiPlus,
  FiEdit2,
  FiTrash2,
  FiPackage,
  FiStar,
  FiTrendingUp,
  FiUploadCloud,
} from "react-icons/fi";
import { getUserRole } from "../components/utilities/getUserRole";
import { MdMonetizationOn } from "react-icons/md";
import ConfirmModal from "../components/ConformModel/ConfirmModal";
const cardShadow = "shadow-sm hover:shadow-md transition-shadow duration-200";

const GiftCardPlaceholderEmoji = ({ name }) => {
  // simple mapping for common gifts — fallback to 🎁
  const map = {
    star: "⭐",
    "gift box": "🎁",
    cake: "🍰",
    chocolate: "🍫",
  };
  const key = (name || "").toLowerCase();
  return <span className="text-4xl">{map[key] || "🎁"}</span>;
};

export default function Gifts() {
  const [loading, setLoading] = useState(true);
  const [gifts, setGifts] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  const [editingGift, setEditingGift] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [fetchingAction, setFetchingAction] = useState(false);
  const[overview,setOverview]=useState('');
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [giftToDelete, setGiftToDelete] = useState(null);


  const [sendModalOpen, setSendModalOpen] = useState(false);

const [usersList, setUsersList] = useState([]);
const [userSearch, setUserSearch] = useState("");
const [usersLoading, setUsersLoading] = useState(false);
const [searchTimeout, setSearchTimeout] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    description: "",
     image: null,
    coinPrice: "",
    category: "",
    tags: "", // comma separated
    active: true,
  });

  useEffect(() => {
    fetchGifts();
  }, []);

 const currentUserRole = getUserRole().role;
  


const fetchUsersList = async (search = "") => {
  try {
    setUsersLoading(true);
    const res = await axios.get("api/v1/user/getusers", {
      params: {
        page: 1,
        limit: 30,
        search: search,
      },
    });
    setUsersList(res.data?.data ?? []);
  } catch (err) {
    console.error("Failed to load users:", err);
  } finally {
    setUsersLoading(false);
  }
};

// Add these useEffect hooks for debounced search
useEffect(() => {
  if (sendModalOpen) {
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    const timeout = setTimeout(() => {
      fetchUsersList(userSearch);
    }, 500);

    setSearchTimeout(timeout);

    return () => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
    };
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [userSearch, sendModalOpen]);

// Fetch initial users when modal opens
useEffect(() => {
  if (sendModalOpen) {
    fetchUsersList("");
    setUserSearch("");
  }
}, [sendModalOpen]);




  const fetchGifts = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/v1/app/gifts");
      if (res?.data?.status === "OK") {
        const data = res.data.data?.gifts || res.data.data || [];
        setGifts(Array.isArray(data) ? data : []);
      } else {
        setGifts(res.data?.data || []);
      }
    } catch (err) {
      console.error("Error fetching gifts:", err);
      setGifts([]);
    } finally {
      setLoading(false);
    }
  };

  // Stats derived from gifts
  const totalGifts = gifts.length;
  const activeGifts = gifts.filter((g) => g.active !== false).length;
  const openAddForm = () => {
    setEditingGift(null);
    setFormData({
      name: "",
      description: "",
      image: null,
      imageUrl: "",
      coinPrice: "",
      category: "",
      tags: "",
      active: true,
    });
    setFormOpen(true);
  };

  const openEditForm = (gift) => {
    setEditingGift(gift);
    setFormData({
      name: gift.name || "",
      description: gift.description || "",
      image: null,
      imageUrl: gift.imageUrl || "",
      coinPrice: gift.coinPrice || gift.coin_price || "",
      category: gift.category || "",
      tags: Array.isArray(gift.tags) ? gift.tags.join(", ") : gift.tags || "",
      active: gift.active !== undefined ? gift.active : true,
    });
    setFormOpen(true);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((p) => ({ ...p, [name]: type === "checkbox" ? checked : value }));
  };



  const handleSubmit = async (e) => {
  e.preventDefault();
  setSubmitting(true);

  try {
    const fd = new FormData();

    fd.append("name", formData.name);
    fd.append("description", formData.description);
    fd.append("coinPrice", Number(formData.coinPrice));
    fd.append("category", formData.category);
    fd.append("isActive", formData.active);

    if (formData.image) {
      fd.append("image", formData.image); // field name MUST match backend
    }

    if (editingGift) {
      const url = `/api/v1/app/gifts/update-Gift/${editingGift._id}`;

      await axios.put(url, fd, {
        headers: { "Content-Type": "multipart/form-data" }
      });

    } else {
      await axios.post("/api/v1/app/gifts/create-new-Gift", fd, {
        headers: { "Content-Type": "multipart/form-data" }
      });
    }

    await fetchGifts();
    setFormOpen(false);

  } catch (err) {
    console.error(err);
    alert("Error saving gift");
  } finally {
    setSubmitting(false);
  }
};




  const handleDelete = async (gift) => {
    setFetchingAction(true);
    try {
      const res = await axios.delete(`/api/v1/app/gifts/${gift._id}`);
      if (res?.data?.success || res.status === 200) {
        setGifts((p) => p.filter((g) => g._id !== gift._id));
      } else {
        throw new Error("Delete failed");
      }
    } catch (err) {
      console.error("Delete error:", err);
      alert("Failed to delete gift");
    } finally {
      setFetchingAction(false);
    }
  };

  const confirmDelete = async () => {
    if (!giftToDelete) return;
    await handleDelete(giftToDelete);
    setConfirmOpen(false);
    setGiftToDelete(null);
  };


    useEffect(()=>{
      fetchOverview()
    },[])
    
  const fetchOverview= async()=>{
    const overviewRes = await axios.get("/api/v1/app/coin-earnings/overview");
        if (overviewRes.data.status === "OK") {
          setOverview(overviewRes.data.data || null);
        }
  }
 
  return (
    <div className={`min-h-screen p-6 bg-[var(--black)] text-[var(--yellow)]`}>
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
        <div className="flex items-center gap-3">
          <FiGift className="text-3xl text-[var(--yellow)]" />
          <h1 className="text-3xl md:text-4xl font-extrabold text-[var(--yellow)]">Gift Management</h1>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={openAddForm}
            className="flex items-center gap-2 px-4 py-2 rounded-md bg-[var(--yellow)] text-[var(--black)] hover:opacity-90 shadow-md"
          >
            <FiPlus className="text-[var(--black)]" />
            Add New Gift
          </button>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-gradient-to-br from-[var(--yellow)]/10 to-[var(--yellow)]/5 border-2 border-[var(--yellow)]/20 rounded-xl p-4 shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-medium text-[color:var(--yellow)/0.8] uppercase tracking-wider">
                Total Gifts
              </p>
              <p className="text-2xl font-bold text-[var(--yellow)]">
                {totalGifts}
              </p>
            </div>
            <div className="text-3xl text-[var(--yellow)]">
              <FiGift />
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-green-500/10 to-green-500/5 border-2 border-green-500/20 rounded-xl p-4 shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-medium text-green-400 uppercase tracking-wider">
                Active Gifts
              </p>
              <p className="text-2xl font-bold text-green-400">
                {activeGifts}
              </p>
            </div>
            <div className="text-3xl text-green-400">
              <FiPackage />
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-blue-500/10 to-blue-500/5 border-2 border-blue-500/20 rounded-xl p-4 shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-medium text-blue-400 uppercase tracking-wider">
                Total Transactions
              </p>
              <p className="text-2xl font-bold text-blue-400">
                {overview?.earningsBySource?.GIFT_RECEIVED?.totalTransactions}
              </p>
            </div>
            <div className="text-3xl text-blue-400">
              <FiTrendingUp />
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-purple-500/10 to-purple-500/5 border-2 border-purple-500/20 rounded-xl p-4 shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-medium text-purple-400 uppercase tracking-wider">
                Coins Spent
              </p>
              <p className="text-2xl font-bold text-purple-400">
                {overview?.earningsBySource?.GIFT_RECEIVED?.totalCoins}
              </p>
            </div>
            <div className="text-3xl text-purple-400">
              <MdMonetizationOn />
            </div>
          </div>
        </div>
      </div>

      {/* Available Gifts */}
      <div className="bg-[var(--black)] rounded-xl p-6 border-2 border-gray-300">
        <h2 className="text-xl font-semibold mb-6 text-[var(--yellow)]">Available Gifts</h2>

        {loading ? (
          <div className="py-16 flex justify-center items-center">
            <div className="animate-spin rounded-full h-10 w-10 border-4 border-[color:var(--yellow)/0.25] border-t-[var(--yellow)]" />
          </div>
        ) : gifts.length === 0 ? (
          <p className="text-[color:var(--yellow)/0.85] py-12 text-center">No gifts found</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-2">
            {gifts.map((gift) => (
              <div
                key={gift._id || gift.id}
                className={`relative overflow-hidden rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-2xl min-h-[200px] ${
                  gift.active === false
                    ? "bg-gradient-to-br from-gray-800 via-gray-700 to-gray-800 border-2 border-gray-600 shadow-md opacity-75"
                    : "bg-gradient-to-br from-gray-900 via-gray-800 to-black border-2 border-[var(--yellow)]/30 shadow-lg shadow-[var(--yellow)]/10"
                }`}
              >
                {/* Background Pattern */}
                <div className="absolute inset-0 opacity-5">
                  <div className="absolute top-4 right-4 w-16 h-16 rounded-full bg-[var(--yellow)]"></div>
                  <div className="absolute bottom-4 left-4 w-12 h-12 rounded-full bg-[var(--yellow)]"></div>
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-20 h-20 rounded-full bg-[var(--yellow)]"></div>
                </div>

                {/* Actions - Top Right */}
                <div className="absolute top-3 right-3 z-20 flex items-center gap-2">
                  <button
                    title="Edit"
                    onClick={() => openEditForm(gift)}
                    className="p-2 rounded-full bg-[var(--yellow)]/10 text-[var(--yellow)] border-2 border-[var(--yellow)]/30 hover:bg-[var(--yellow)]/20 hover:scale-110 transition-all duration-200"
                  >
                    <FiEdit2 className="w-4 h-4" />
                  </button>

                  {currentUserRole == 'super-admin' && (
                    <button
                      title="Delete"
                      onClick={() => {
                        setGiftToDelete(gift);
                        setConfirmOpen(true);
                      }}
                      className="p-2 rounded-full bg-red-500/10 text-red-400 border-2 border-red-400/30 hover:bg-red-500/20 hover:scale-110 transition-all duration-200"
                    >
                      <FiTrash2 className="w-4 h-4" />
                    </button>
                  )}
                </div>

                <div className="relative z-10 p-3 pt-12">
                  {/* Image and Content Row */}
                  <div className="flex items-start gap-3 mb-3">
                    {/* Gift Image/Icon - Left Side */}
                    <div className="flex-shrink-0">
                      {gift.image?.url ? (
                        <img
                          src={gift.image.url}
                          alt={gift.name}
                          className="w-12 h-12 object-contain rounded-lg"
                        />
                      ) : (
                        <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[color:var(--yellow)/0.1] border border-[var(--yellow)]/20">
                          <GiftCardPlaceholderEmoji name={gift.name} />
                        </div>
                      )}
                    </div>

                    {/* Text Content - Centered */}
                    <div className="flex-1 text-center">
                      {/* Gift Name */}
                      <h3 className="font-bold text-sm mb-2 text-[var(--yellow)] truncate">{gift.name}</h3>

                      {/* Description */}
                      <p className="text-xs text-[color:var(--yellow)/0.8] line-clamp-2 leading-tight">{gift.description}</p>
                    </div>
                  </div>

                  {/* Price Section - Centered */}
                  <div className="bg-black/30 rounded-md p-2 mb-3 border border-[var(--yellow)]/20">
                    <div className="flex items-center justify-center gap-1">
                      {/* <MdMonetizationOn className="text-[var(--yellow)] w-4 h-4" /> */}
                      <div className="text-sm font-bold text-[var(--yellow)]">{gift.coinPrice || gift.coin_price || 0}</div>
                      <div className="text-xs text-[color:var(--yellow)/0.8] uppercase tracking-wider">coins</div>
                    </div>
                  </div>

                  {/* Tags and Status - Centered */}
                  <div className="flex items-center justify-center gap-1 flex-wrap">
                    {(gift.tags || []).slice?.(0, 2)?.map?.((t, idx) => (
                      <span
                        key={idx}
                        className="text-xs px-2 py-0.5 rounded-full border border-[var(--yellow)]/30 text-[var(--yellow)] bg-[color:var(--yellow)/0.08] font-medium"
                      >
                        {t}
                      </span>
                    ))}

                    <span
                      className={`text-xs px-2 py-0.5 rounded-full font-semibold ${
                        gift.active === false
                          ? "border border-red-400/30 text-red-300 bg-red-500/10"
                          : "border border-green-400/30 text-green-300 bg-green-500/10"
                      }`}
                    >
                      {gift.active === false ? "Inactive" : "Active"}
                    </span>
                  </div>

                  {/* Inactive Overlay */}
                  {gift.active === false && (
                    <div className="absolute inset-0 bg-red-500/5 border-2 border-red-500/20 rounded-xl flex items-center justify-center">
                      <div className="bg-red-500/10 border border-red-500/20 rounded-lg px-3 py-1">
                        <div className="flex items-center gap-1">
                          <div className="w-1.5 h-1.5 bg-red-400 rounded-full animate-pulse"></div>
                          <span className="text-xs text-red-300 font-medium">Inactive</span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Modal Form (Add / Edit) */}
      {formOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[var(--black)] px-4">
          <div className="bg-[var(--black)] w-full max-w-2xl rounded-lg p-6 border-2 border-gray-300">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-[var(--yellow)]">{editingGift ? "Edit Gift" : "Create a New Gift"}</h3>
              <button
                onClick={() => setFormOpen(false)}
                className="text-[var(--yellow)] hover:opacity-90"
              >
                ✕
              </button>
            </div>

            <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1 text-[var(--yellow)]">Gift Name</label>
                <input
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full border-2 border-gray-300 rounded-md px-3 py-2 bg-[var(--black)] text-[var(--yellow)]"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1 text-[var(--yellow)]">Category</label>
                <select
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  required
                  className="w-full border-2 border-gray-300 rounded-md px-3 py-2 bg-[var(--black)] text-[var(--yellow)]"
                >
                  <option value="" className="bg-[var(--black)] text-[var(--yellow)]">Select a Category</option>
                  <option value="romantic">Romantic</option>
                  <option value="friendship">Friendship</option>
                  <option value="celebration">Celebration</option>
                  <option value="appreciation">Appreciation</option>
                  <option value="fun">Fun</option>
                </select>
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1 text-[var(--yellow)]">Description</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  rows="3"
                  className="w-full border-2 border-gray-300 rounded-md px-3 py-2 bg-[var(--black)] text-[var(--yellow)]"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1 text-[var(--yellow)]">
                  Gift Image
                </label>
                <label
                  htmlFor="gift-image"
                  className="group flex cursor-pointer items-center gap-4 rounded-lg border-2 border-dashed border-[var(--yellow)]/35 bg-[color:var(--yellow)/0.04] px-4 py-3 transition-all duration-200 hover:border-[var(--yellow)] hover:bg-[color:var(--yellow)/0.1]"
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-[var(--yellow)] text-[var(--black)] shadow-sm transition-transform duration-200 group-hover:scale-105">
                    <FiUploadCloud className="h-5 w-5" />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate text-sm font-medium text-[var(--yellow)]">
                      {formData.image ? formData.image.name : "Choose an image to upload"}
                    </span>
                    <span className="mt-0.5 block text-xs text-[color:var(--yellow)/0.65]">
                      PNG, JPG, WEBP, or GIF
                    </span>
                  </span>
                  <span className="rounded-md border border-[var(--yellow)]/50 px-3 py-1.5 text-xs font-semibold text-[var(--yellow)] transition-colors group-hover:bg-[var(--yellow)] group-hover:text-[var(--black)]">
                    Browse
                  </span>
                  <input
                    id="gift-image"
                    type="file"
                    accept="image/*"
                    className="sr-only"
                    onChange={(e) =>
                      setFormData((p) => ({
                        ...p,
                        image: e.target.files?.[0] || null,
                      }))
                    }
                  />
                </label>
              </div>


              <div>
                <label className="block text-sm font-medium mb-1 text-[var(--yellow)]">Coin Price</label>
                <input
                  name="coinPrice"
                  type="number"
                  value={formData.coinPrice}
                  onChange={handleChange}
                  required
                  className="w-full border-2 border-gray-300 rounded-md px-3 py-2 bg-[var(--black)] text-[var(--yellow)]"
                />
              </div>

              <div className="flex items-center gap-3">
                <input
                  id="active"
                  name="active"
                  type="checkbox"
                  checked={!!formData.active}
                  onChange={handleChange}
                  className="accent-[var(--yellow)]"
                />
                <label htmlFor="active" className="text-sm text-[var(--yellow)]">Active</label>
              </div>

              <div className="md:col-span-2 flex justify-end gap-3">
                <button
                  type="button"
                  onClick={() => setFormOpen(false)}
                  className="px-4 py-2 border-2 border-gray-300 text-[var(--yellow)] rounded-md hover:bg-[color:var(--yellow)/0.06]"
                >
                  Cancel
                </button>
               <button
  type="submit"
  disabled={submitting}
  className={`px-5 py-2 rounded-md font-medium transition-all duration-200 flex items-center justify-center gap-2
    ${
      submitting
        ? "bg-gray-400 text-gray-700 cursor-not-allowed opacity-80"
        : "bg-[var(--yellow)] text-[var(--black)] hover:opacity-90"
    }`}
>
  {submitting ? (
    <>
      <span className="w-4 h-4 border-2 border-gray-700 border-t-transparent rounded-full animate-spin"></span>
      Saving...
    </>
  ) : (
    editingGift ? "Update Gift" : "Create Gift"
  )}
</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <ConfirmModal
        isOpen={confirmOpen}
        title="Delete Gift?"
        message="Are you sure you want to delete this gift? This action cannot be undone."
        onConfirm={confirmDelete} 
         block="Delete"
        onCancel={() => {
          setConfirmOpen(false);
          setGiftToDelete(null);
        }}
      />
    </div>
  );
}
